export default __webpack_public_path__ + "static/media/living-room-reverse.9bae57bc.mp4";